<template>
  <el-select
    v-model="selectedWarehouse"
    @input="emitInput()"
    @change="emitChange()"
    ref="warehouse-select"
    :disabled="disabled"
  >
    <el-option
      v-for="warehouse in filteredOutboundWarehouses"
      :key="warehouse.id"
      :label="warehouse.name"
      :value="warehouse.id"
    ></el-option>
  </el-select>
</template>

<script>
import warehouseService from '@/api/warehouseService';

export default {
  name: 'OutboundWarehouseSelect',
  props: ['value', 'includeOptionAll', 'excludeWarehouseId', 'excludeWarehouseCode', 'disabled'],
  watch: {
    value(newValue) {
      this.selectedWarehouse = newValue;
    },
    excludeWarehouseId() {
      this.filterOutboundWarehouses();
    },
    excludeWarehouseCode() {
      this.filterOutboundWarehouses();
    }
  },
  data() {
    return {
      selectedWarehouse: this.value,
      outboundWarehouses: [],
      filteredOutboundWarehouses: []
    };
  },
  mounted() {
    if (this.includeOptionAll) {
      this.outboundWarehouses = [
        {
          id: null,
          name: this.$t('common.all')
        }
      ];
    }

    warehouseService.getOutboundWarehouses().then((response) => {
      this.outboundWarehouses = this.outboundWarehouses.concat(
        response.data.map(warehouse => ({
          id: warehouse.id,
          name: warehouse.code
        }))
      );

      this.filterOutboundWarehouses();
    });
  },
  methods: {
    emitInput() {
      this.$emit('update:value', this.selectedWarehouse);
      this.$emit('input', this.selectedWarehouse);
    },
    emitChange() {
      this.$emit('update:value', this.selectedWarehouse);
      this.$emit('change', this.selectedWarehouse);
    },
    setSelectedWarehouse(selected) {
      this.selectedWarehouse = selected;
    },
    filterOutboundWarehouses() {
      let ow = this.outboundWarehouses;

      if (this.excludeWarehouseId) {
        ow = this.outboundWarehouses.filter(warehouse => warehouse.id !== this.excludeWarehouseId);
      }

      if (this.excludeWarehouseCode) {
        ow = ow.filter(warehouse => warehouse.name !== this.excludeWarehouseCode);
      }

      this.filteredOutboundWarehouses = ow;
    }
  }
};
</script>
